module.exports = __webpack_public_path__ + "img/icon_disadvantage.41523b8a.png";